(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    function initCollection(sectionRoot) {
      if (!sectionRoot || sectionRoot.dataset.mossCollectionInit === 'true') {
        return;
      }

      sectionRoot.dataset.mossCollectionInit = 'true';

      var filterSelects = Array.prototype.slice.call(
        sectionRoot.querySelectorAll('[data-storefront-filter]')
      );
      var cards = Array.prototype.slice.call(sectionRoot.querySelectorAll('[data-filter-card]'));

      function initCardImageCycle(cardRoot) {
        if (!cardRoot || cardRoot.dataset.cardCycleReady === 'true') {
          return;
        }

        var media = cardRoot.querySelector('[data-card-media]');
        if (!media) {
          cardRoot.dataset.cardCycleReady = 'true';
          return;
        }

        var images = Array.prototype.slice.call(media.querySelectorAll('.moss-collection__image'));
        var progressSteps = Array.prototype.slice.call(media.querySelectorAll('[data-card-progress-step]'));

        if (images.length <= 1 || progressSteps.length <= 1) {
          cardRoot.dataset.cardCycleReady = 'true';
          return;
        }

        var cycleDuration = Number(media.dataset.cycleDuration || 1600);
        if (!isFinite(cycleDuration) || cycleDuration < 350) {
          cycleDuration = 1600;
        }

        var activeIndex = 0;
        var rafId = null;
        var isRunning = false;
        var cycleStartTime = 0;

        function setProgress(step, value) {
          if (!step) {
            return;
          }
          var fill = step.querySelector('[data-card-progress-fill]');
          if (!fill) {
            return;
          }
          var normalized = Math.max(0, Math.min(100, value));
          fill.style.setProperty('--card-progress', normalized + '%');
        }

        function resetProgress() {
          progressSteps.forEach(function (step) {
            step.classList.remove('is-active');
            setProgress(step, 0);
          });
        }

        function setActiveImage(index) {
          activeIndex = index;

          images.forEach(function (image, imageIndex) {
            image.classList.toggle('is-active', imageIndex === index);
          });

          progressSteps.forEach(function (step, stepIndex) {
            var isCurrent = stepIndex === index;
            step.classList.toggle('is-active', isCurrent);

            if (stepIndex < index) {
              setProgress(step, 100);
            } else if (stepIndex > index) {
              setProgress(step, 0);
            }
          });

          setProgress(progressSteps[index], 0);
        }

        function stopCycle() {
          isRunning = false;
          cardRoot.classList.remove('is-cycling');

          if (rafId) {
            window.cancelAnimationFrame(rafId);
            rafId = null;
          }

          resetProgress();
          images.forEach(function (image, index) {
            image.classList.toggle('is-active', index === 0);
          });
        }

        function frame(now) {
          if (!isRunning) {
            return;
          }

          var elapsed = now - cycleStartTime;
          var progress = Math.max(0, Math.min(1, elapsed / cycleDuration));
          setProgress(progressSteps[activeIndex], progress * 100);

          if (progress >= 1) {
            setProgress(progressSteps[activeIndex], 100);

            var nextIndex = activeIndex + 1;
            if (nextIndex >= images.length) {
              nextIndex = 0;
              resetProgress();
            }

            cycleStartTime = now;
            setActiveImage(nextIndex);
          }

          rafId = window.requestAnimationFrame(frame);
        }

        function startCycle() {
          if (isRunning) {
            return;
          }

          resetProgress();
          setActiveImage(0);
          isRunning = true;
          cardRoot.classList.add('is-cycling');
          cycleStartTime = window.performance && performance.now ? performance.now() : Date.now();
          rafId = window.requestAnimationFrame(frame);
        }

        cardRoot.addEventListener('mouseenter', startCycle);
        cardRoot.addEventListener('mouseleave', stopCycle);
        cardRoot.addEventListener('focusin', startCycle);
        cardRoot.addEventListener('focusout', function () {
          window.setTimeout(function () {
            if (!cardRoot.contains(document.activeElement)) {
              stopCycle();
            }
          }, 0);
        });

        cardRoot.dataset.cardCycleReady = 'true';
      }

      cards.forEach(initCardImageCycle);

      function navigateWithFilters() {
        var url = new URL(window.location.href);
        filterSelects.forEach(function (select) {
          var param = select.dataset.filterParam;
          if (!param) {
            return;
          }
          url.searchParams.delete(param);
          if (select.value) {
            url.searchParams.set(param, select.value);
          }
        });
        url.searchParams.delete('page');
        window.location.href = url.toString();
      }

      filterSelects.forEach(function (select) {
        select.addEventListener('change', navigateWithFilters);
      });
    }

    function initAll(root) {
      var scope = root || document;

      if (scope.matches) {
        if (scope.matches('[data-moss-collection]')) {
          initCollection(scope);
        }
      }

      scope.querySelectorAll('[data-moss-collection]').forEach(initCollection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event && event.target) {
        initAll(event.target);
      }
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function initHeader(sectionRoot) {
      if (!sectionRoot || sectionRoot.dataset.mossHeaderInit === 'true') {
        return;
      }

      sectionRoot.dataset.mossHeaderInit = 'true';

      var isHomeTemplate = sectionRoot.classList.contains('moss-header--home-template');
      var isProductTemplate = sectionRoot.classList.contains('moss-header--product-template');

      function updateDrawerTop() {
        sectionRoot.style.setProperty('--header-drawer-top', sectionRoot.getBoundingClientRect().height + 'px');
      }

      function updateScrolledState() {
        var shouldBeScrolled = true;

        if (isHomeTemplate) {
          shouldBeScrolled = window.scrollY > 0;
        } else if (isProductTemplate && window.matchMedia('(max-width: 899px)').matches) {
          shouldBeScrolled = window.scrollY > 8;
        }

        sectionRoot.classList.toggle('is-scrolled', shouldBeScrolled);
      }

      updateScrolledState();
      updateDrawerTop();
      window.addEventListener('scroll', updateScrolledState, { passive: true });
      window.addEventListener('resize', updateScrolledState);
      window.addEventListener('resize', updateDrawerTop);
      window.addEventListener('load', updateDrawerTop);

      var toggle = sectionRoot.querySelector('[data-mobile-nav-toggle]');
      var panel = sectionRoot.querySelector('[data-mobile-nav-panel]');
      var searchToggle = sectionRoot.querySelector('[data-header-search-toggle]');
      var searchPanel = sectionRoot.querySelector('[data-header-search-panel]');
      var searchInput = sectionRoot.querySelector('[data-header-search-input]');
      var searchClear = sectionRoot.querySelector('[data-header-search-clear]');
      var searchResults = sectionRoot.querySelector('[data-header-search-results]');
      var searchGrid = sectionRoot.querySelector('[data-header-search-grid]');
      var searchStatus = sectionRoot.querySelector('[data-header-search-status]');
      var searchViewAll = sectionRoot.querySelector('[data-header-search-view-all]');
      var searchBaseUrl = sectionRoot.dataset.searchUrl || '/search';
      var searchDebounceTimer = null;
      var searchAbortController = null;
      var searchLastQuery = '';
      var cartItem = sectionRoot.querySelector('[data-header-cart-item]');
      var cartToggles = Array.prototype.slice.call(sectionRoot.querySelectorAll('[data-header-cart-toggle]'));
      var cartToggle = cartToggles[0];
      var cartClose = sectionRoot.querySelector('[data-header-cart-close]');
      var cartPreview = sectionRoot.querySelector('[data-header-cart-preview]');
      var cartPreviewItems = sectionRoot.querySelector('[data-header-cart-preview-items]');
      var cartSubtotal = sectionRoot.querySelector('[data-header-cart-subtotal]');
      var cartCount = sectionRoot.querySelector('[data-header-cart-count]');
      var cartAddUrl = sectionRoot.dataset.cartAddUrl || '/cart/add.js';
      var cartJsonUrl = sectionRoot.dataset.cartJsonUrl || '/cart.js';
      var cartChangeUrl = '/cart/change.js';
      var cartPreviewIsSubmitting = false;
      var dropdownItems = Array.prototype.slice.call(
        sectionRoot.querySelectorAll('.moss-header__item--has-dropdown:not(.moss-header__item--shop):not(.moss-header__item--brands)')
      );
      var shopDropdownItem = sectionRoot.querySelector('.moss-header__item--shop');
      var brandsDropdownItem = sectionRoot.querySelector('.moss-header__item--brands');
      var setActiveBrand = null;
      var shopDropdownCloseTimer = null;
      var brandsDropdownCloseTimer = null;

      function setDropdownOpenState(isOpen) {
        sectionRoot.classList.toggle('is-dropdown-open', isOpen);
      }

      function escapeHtml(value) {
        if (value == null) {
          return '';
        }

        return String(value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      function formatMoney(cents, currencyCode) {
        var amount = Number(cents || 0) / 100;
        if (!isFinite(amount)) {
          amount = 0;
        }

        try {
          var formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency',
            currency: currencyCode || (window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD')
          });
          return formatter.format(amount);
        } catch (error) {
          return '$' + amount.toFixed(2);
        }
      }

      function initBrandProductCardCycle(cardRoot) {
        if (!cardRoot || cardRoot.dataset.cardCycleReady === 'true') {
          return;
        }

        var media = cardRoot.querySelector('[data-card-media]');
        if (!media) {
          cardRoot.dataset.cardCycleReady = 'true';
          return;
        }

        var images = Array.prototype.slice.call(media.querySelectorAll('.moss-header__brand-product-image'));
        var progressSteps = Array.prototype.slice.call(media.querySelectorAll('[data-card-progress-step]'));

        if (images.length <= 1 || progressSteps.length <= 1) {
          cardRoot.dataset.cardCycleReady = 'true';
          return;
        }

        var cycleDuration = Number(media.dataset.cycleDuration || 1600);
        if (!isFinite(cycleDuration) || cycleDuration < 350) {
          cycleDuration = 1600;
        }

        var activeIndex = 0;
        var rafId = null;
        var isRunning = false;
        var cycleStartTime = 0;

        function setProgress(step, value) {
          if (!step) {
            return;
          }
          var fill = step.querySelector('[data-card-progress-fill]');
          if (!fill) {
            return;
          }
          var normalized = Math.max(0, Math.min(100, value));
          fill.style.setProperty('--card-progress', normalized + '%');
        }

        function resetProgress() {
          progressSteps.forEach(function (step) {
            step.classList.remove('is-active');
            setProgress(step, 0);
          });
        }

        function setActiveImage(index) {
          activeIndex = index;

          images.forEach(function (image, imageIndex) {
            image.classList.toggle('is-active', imageIndex === index);
          });

          progressSteps.forEach(function (step, stepIndex) {
            var isCurrent = stepIndex === index;
            step.classList.toggle('is-active', isCurrent);

            if (stepIndex < index) {
              setProgress(step, 100);
            } else if (stepIndex > index) {
              setProgress(step, 0);
            }
          });

          setProgress(progressSteps[index], 0);
        }

        function stopCycle() {
          isRunning = false;
          cardRoot.classList.remove('is-cycling');

          if (rafId) {
            window.cancelAnimationFrame(rafId);
            rafId = null;
          }

          resetProgress();
          images.forEach(function (image, index) {
            image.classList.toggle('is-active', index === 0);
          });
        }

        function frame(now) {
          if (!isRunning) {
            return;
          }

          var elapsed = now - cycleStartTime;
          var progress = Math.max(0, Math.min(1, elapsed / cycleDuration));
          setProgress(progressSteps[activeIndex], progress * 100);

          if (progress >= 1) {
            setProgress(progressSteps[activeIndex], 100);

            var nextIndex = activeIndex + 1;
            if (nextIndex >= images.length) {
              nextIndex = 0;
              resetProgress();
            }

            cycleStartTime = now;
            setActiveImage(nextIndex);
          }

          rafId = window.requestAnimationFrame(frame);
        }

        function startCycle() {
          if (isRunning) {
            return;
          }

          resetProgress();
          setActiveImage(0);
          isRunning = true;
          cardRoot.classList.add('is-cycling');
          cycleStartTime = window.performance && performance.now ? performance.now() : Date.now();
          rafId = window.requestAnimationFrame(frame);
        }

        cardRoot.addEventListener('mouseenter', startCycle);
        cardRoot.addEventListener('mouseleave', stopCycle);
        cardRoot.addEventListener('focusin', startCycle);
        cardRoot.addEventListener('focusout', function () {
          window.setTimeout(function () {
            if (!cardRoot.contains(document.activeElement)) {
              stopCycle();
            }
          }, 0);
        });

        cardRoot.dataset.cardCycleReady = 'true';
      }

      function syncCartCount(count) {
        if (!cartCount) {
          return;
        }

        var safeCount = Number(count || 0);
        if (!isFinite(safeCount) || safeCount < 0) {
          safeCount = 0;
        }

        cartCount.textContent = '(' + safeCount + ')';
        cartCount.classList.toggle('is-hidden', safeCount === 0);
      }

      function setCartPreviewOpen(isOpen) {
        if (!cartItem || !cartPreview) {
          return;
        }

        cartItem.classList.toggle('is-open', isOpen);
        sectionRoot.classList.toggle('is-cart-open', isOpen);
        cartPreview.setAttribute('aria-hidden', String(!isOpen));
        cartToggles.forEach(function (toggleButton) {
          toggleButton.setAttribute('aria-expanded', String(isOpen));
        });
        updateHeaderDropdownState();
      }

      function renderCartPreview(cartData) {
        if (!cartData) {
          return;
        }

        syncCartCount(cartData.item_count);
        if (cartPreview) {
          cartPreview.classList.toggle('is-empty', !cartData.items || !cartData.items.length);
        }

        if (cartSubtotal) {
          cartSubtotal.textContent = formatMoney(cartData.total_price, cartData.currency);
        }

        if (!cartPreviewItems) {
          return;
        }

        if (!cartData.items || !cartData.items.length) {
          var emptyShopUrl = cartPreview ? cartPreview.dataset.shopUrl || '/' : '/';
          cartPreviewItems.innerHTML =
            '<div class="moss-header__cart-preview-empty"><p>Your cart is empty.</p><a href="' +
            escapeHtml(emptyShopUrl) +
            '">Shop Now</a></div>';
          return;
        }

        var itemsMarkup = cartData.items
          .map(function (item) {
            var title = item.product_title || item.title || 'Product';
            var vendor = item.vendor || item.product_vendor || '';
            var variantTitle = item.variant_title || '';
            var linePrice = formatMoney(item.final_line_price, cartData.currency);
            var quantity = Number(item.quantity || 0);
            var imageUrl = '';

            if (item.featured_image && item.featured_image.url) {
              imageUrl = item.featured_image.url;
            } else if (item.image) {
              imageUrl = item.image;
            }

            if (imageUrl) {
              if (imageUrl.indexOf('?') === -1) {
                imageUrl += '?width=240';
              } else {
                imageUrl += '&width=240';
              }
            }

            var mediaMarkup = imageUrl
              ? '<img class="moss-header__cart-line-image" loading="lazy" alt="" src="' + escapeHtml(imageUrl) + '">'
              : '<svg class="moss-header__cart-line-image placeholder-svg" viewBox="0 0 100 120" aria-hidden="true"><rect width="100" height="120" fill="#f1f1ef"></rect></svg>';

            var variantMarkup = '';
            if (variantTitle && variantTitle !== 'Default Title') {
              variantMarkup = '<p class="moss-header__cart-line-variant">' + escapeHtml(variantTitle) + '</p>';
            }

            return (
              '<article class="moss-header__cart-line">' +
              '<a class="moss-header__cart-line-media" href="' +
              escapeHtml(item.url || '#') +
              '" data-cart-product-link' +
              '">' +
              mediaMarkup +
              '</a>' +
              '<div class="moss-header__cart-line-details">' +
              '<p class="moss-header__cart-line-vendor">' +
              escapeHtml(vendor) +
              '</p>' +
              '<h3><a href="' +
              escapeHtml(item.url || '#') +
              '">' +
              escapeHtml(title) +
              '</a></h3>' +
              variantMarkup +
              '<div class="moss-header__cart-line-bottom"><span>Qty ' +
              escapeHtml(String(quantity)) +
              '</span><strong>' +
              escapeHtml(linePrice) +
              '</strong></div>' +
              '<a class="moss-header__cart-line-remove" href="#" data-cart-remove data-cart-line-key="' +
              escapeHtml(item.key || '') +
              '">Remove</a>' +
              '</div>' +
              '</article>'
            );
          })
          .join('');

        cartPreviewItems.innerHTML = itemsMarkup;
      }

      function refreshCartPreview() {
        return fetch(cartJsonUrl, {
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Cart fetch failed');
            }
            return response.json();
          })
          .then(renderCartPreview);
      }

      function setSearchOpenState(isOpen, options) {
        if (!searchToggle || !searchPanel) {
          return;
        }

        var shouldFocus = true;
        if (options && options.focusInput === false) {
          shouldFocus = false;
        }

        sectionRoot.classList.toggle('is-search-open', isOpen);
        searchToggle.setAttribute('aria-expanded', String(isOpen));

        if (!isOpen) {
          if (searchResults) searchResults.hidden = true;
          updateHeaderDropdownState();
          return;
        }

        setCartPreviewOpen(false);

        if (shopDropdownItem) {
          shopDropdownItem.classList.remove('is-open');
        }
        if (brandsDropdownItem) {
          brandsDropdownItem.classList.remove('is-open');
        }

        updateHeaderDropdownState();

        if (shouldFocus && searchInput) {
          window.requestAnimationFrame(function () {
            searchInput.focus();
            searchInput.select();
          });
        }
      }

      function syncSearchClearState() {
        if (!searchInput || !searchClear) {
          return;
        }

        var hasValue = searchInput.value.trim() != '';
        searchClear.disabled = !hasValue;
      }

      function updateHeaderDropdownState() {
        var shouldBeOpen = false;

        if (shopDropdownItem && shopDropdownItem.classList.contains('is-open')) {
          shouldBeOpen = true;
        }

        if (brandsDropdownItem && brandsDropdownItem.classList.contains('is-open')) {
          shouldBeOpen = true;
        }

        if (!shouldBeOpen) {
          dropdownItems.forEach(function (item) {
            if (item.matches(':hover') || item.contains(document.activeElement)) {
              shouldBeOpen = true;
            }
          });
        }

        if (sectionRoot.classList.contains('is-search-open')) {
          shouldBeOpen = true;
        }

        setDropdownOpenState(shouldBeOpen);
      }

      if (dropdownItems.length) {
        dropdownItems.forEach(function (item) {
          item.addEventListener('mouseenter', function () {
            updateHeaderDropdownState();
          });

          item.addEventListener('mouseleave', function () {
            updateHeaderDropdownState();
          });

          item.addEventListener('focusin', function () {
            updateHeaderDropdownState();
          });

          item.addEventListener('focusout', function () {
            window.setTimeout(function () {
              updateHeaderDropdownState();
            }, 0);
          });
        });
      }

      if (shopDropdownItem) {
        function clearShopCloseTimer() {
          if (shopDropdownCloseTimer) {
            window.clearTimeout(shopDropdownCloseTimer);
            shopDropdownCloseTimer = null;
          }
        }

        function openShopDropdown() {
          setSearchOpenState(false, { focusInput: false });
          setCartPreviewOpen(false);
          clearShopCloseTimer();
          shopDropdownItem.classList.add('is-open');
          updateHeaderDropdownState();
        }

        function closeShopDropdownSoon() {
          clearShopCloseTimer();
          shopDropdownCloseTimer = window.setTimeout(function () {
            shopDropdownItem.classList.remove('is-open');
            updateHeaderDropdownState();
          }, 140);
        }

        shopDropdownItem.addEventListener('mouseenter', openShopDropdown);
        shopDropdownItem.addEventListener('mouseleave', closeShopDropdownSoon);
        shopDropdownItem.addEventListener('focusin', openShopDropdown);
        shopDropdownItem.addEventListener('focusout', function () {
          window.setTimeout(function () {
            if (!shopDropdownItem.contains(document.activeElement)) {
              closeShopDropdownSoon();
            }
          }, 0);
        });
      }

      if (brandsDropdownItem) {
        function clearBrandsCloseTimer() {
          if (brandsDropdownCloseTimer) {
            window.clearTimeout(brandsDropdownCloseTimer);
            brandsDropdownCloseTimer = null;
          }
        }

        function openBrandsDropdown() {
          setSearchOpenState(false, { focusInput: false });
          setCartPreviewOpen(false);
          clearBrandsCloseTimer();
          if (setActiveBrand) {
            setActiveBrand(null);
          }
          brandsDropdownItem.classList.add('is-open');
          updateHeaderDropdownState();
        }

        function closeBrandsDropdownSoon() {
          clearBrandsCloseTimer();
          brandsDropdownCloseTimer = window.setTimeout(function () {
            brandsDropdownItem.classList.remove('is-open');
            updateHeaderDropdownState();
          }, 150);
        }

        brandsDropdownItem.addEventListener('mouseenter', openBrandsDropdown);
        brandsDropdownItem.addEventListener('mouseleave', closeBrandsDropdownSoon);
        brandsDropdownItem.addEventListener('focusin', openBrandsDropdown);
        brandsDropdownItem.addEventListener('focusout', function () {
          window.setTimeout(function () {
            if (!brandsDropdownItem.contains(document.activeElement)) {
              closeBrandsDropdownSoon();
            }
          }, 0);
        });
      }

      var brandTriggers = Array.prototype.slice.call(sectionRoot.querySelectorAll('[data-header-brand-trigger]'));
      var brandPanels = Array.prototype.slice.call(sectionRoot.querySelectorAll('[data-header-brand-panel]'));

      if (brandTriggers.length && brandPanels.length) {
        setActiveBrand = function (index) {
          var hasActiveIndex = index !== null && index !== undefined;
          brandTriggers.forEach(function (trigger) {
            var isActive = false;
            if (hasActiveIndex) {
              isActive = Number(trigger.dataset.brandIndex || 0) === index;
            }
            trigger.classList.toggle('is-active', isActive);
          });

          brandPanels.forEach(function (panel) {
            var isActive = false;
            if (hasActiveIndex) {
              isActive = Number(panel.dataset.brandIndex || 0) === index;
            }
            panel.classList.toggle('is-active', isActive);
          });
        };

        brandTriggers.forEach(function (trigger) {
          var index = Number(trigger.dataset.brandIndex || 0);

          trigger.addEventListener('mouseenter', function () {
            setActiveBrand(index);
          });

          trigger.addEventListener('focus', function () {
            setActiveBrand(index);
          });
        });

        setActiveBrand(null);
      }

      sectionRoot.querySelectorAll('.moss-header__brand-product').forEach(initBrandProductCardCycle);

      if (cartItem && cartPreview) {
        if (cartToggles.length) {
          cartToggles.forEach(function (toggleButton) {
            toggleButton.addEventListener('click', function (event) {
              event.preventDefault();
              var isOpen = cartItem.classList.contains('is-open');
              setSearchOpenState(false, { focusInput: false });
              if (shopDropdownItem) {
                shopDropdownItem.classList.remove('is-open');
              }
              if (brandsDropdownItem) {
                brandsDropdownItem.classList.remove('is-open');
              }
              setCartPreviewOpen(!isOpen);
              if (!isOpen) {
                refreshCartPreview().catch(function () {});
              }
            });
          });
        }

        if (cartClose) {
          cartClose.addEventListener('click', function () {
            setCartPreviewOpen(false);
            if (cartToggle) {
              cartToggle.focus();
            }
          });
        }

        cartItem.addEventListener('click', function (event) {
          if (event.target === cartItem) {
            setCartPreviewOpen(false);
          }
        });

        cartPreview.addEventListener('click', function (event) {
          var removeLink = event.target.closest('[data-cart-remove]');
          if (!removeLink) {
            return;
          }

          event.preventDefault();

          var lineKey = removeLink.dataset.cartLineKey || '';
          if (!lineKey) {
            return;
          }

          removeLink.setAttribute('aria-disabled', 'true');

          fetch(cartChangeUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: lineKey,
              quantity: 0
            })
          })
            .then(function (response) {
              if (!response.ok) {
                throw new Error('Cart remove failed');
              }
              return response.json();
            })
            .then(renderCartPreview)
            .catch(function () {
              refreshCartPreview().catch(function () {});
            })
            .finally(function () {
              removeLink.removeAttribute('aria-disabled');
            });
        });

        document.addEventListener('keydown', function (event) {
          if (!sectionRoot.isConnected) {
            return;
          }

          if (event.key !== 'Escape') {
            return;
          }

          if (!cartItem.classList.contains('is-open')) {
            return;
          }

          setCartPreviewOpen(false);
        });

        document.addEventListener('click', function (event) {
          if (!sectionRoot.isConnected) {
            return;
          }

          if (!cartItem.classList.contains('is-open')) {
            return;
          }

          if (cartItem.contains(event.target)) {
            return;
          }

          setCartPreviewOpen(false);
        });

        document.addEventListener('submit', function (event) {
          if (!sectionRoot.isConnected) {
            return;
          }

          var form = event.target;
          if (!form || !form.matches || !form.matches('form')) {
            return;
          }

          var action = form.getAttribute('action') || '';
          if (action.indexOf('/cart/add') === -1) {
            return;
          }

          if (cartPreviewIsSubmitting) {
            event.preventDefault();
            return;
          }

          event.preventDefault();
          cartPreviewIsSubmitting = true;

          var submitter = event.submitter;
          var submitterResetLabel = '';
          if (submitter && submitter.disabled !== undefined) {
            submitterResetLabel = submitter.textContent || '';
            if (submitter.matches && submitter.matches('[data-add-to-cart]')) {
              var productRoot = submitter.closest('[data-moss-product]');
              if (productRoot && productRoot.dataset && productRoot.dataset.addLabel) {
                submitterResetLabel = productRoot.dataset.addLabel;
              }
            }
            submitter.disabled = true;
          }

          var payload = new FormData(form);

          fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: payload
          })
            .then(function (response) {
              if (!response.ok) {
                throw new Error('Add to cart failed');
              }
              return response.json();
            })
            .then(function () {
              return fetch(cartJsonUrl, {
                headers: {
                  Accept: 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                }
              });
            })
            .then(function (response) {
              if (!response.ok) {
                throw new Error('Cart fetch failed');
              }
              return response.json();
            })
            .then(function (cartData) {
              renderCartPreview(cartData);
              setCartPreviewOpen(true);
            })
            .catch(function () {
              form.submit();
            })
            .finally(function () {
              cartPreviewIsSubmitting = false;
              if (submitter && submitter.disabled !== undefined) {
                submitter.disabled = false;
                if (submitterResetLabel && submitter.matches && submitter.matches('[data-add-to-cart]')) {
                  submitter.textContent = submitterResetLabel;
                }
              }
            });
        });
      }

      function renderSearchCard(product) {
        var title = escapeHtml(product.title || '');
        var vendor = escapeHtml(product.vendor || '');
        var url = product.url || ('/products/' + (product.handle || ''));
        var imgUrl = '';
        if (product.featured_image && product.featured_image.url) {
          imgUrl = product.featured_image.url;
        } else if (product.image) {
          imgUrl = product.image;
        } else if (product.images && product.images.length) {
          imgUrl = product.images[0];
        }
        var imageHtml = imgUrl
          ? '<img src="' + escapeHtml(imgUrl) + '" alt="' + title + '" loading="lazy">'
          : '<div style="width:100%;height:100%;background:#e8e4df"></div>';

        var price = Math.round(Number(product.price || 0) * 100);
        var compareAt = Math.round(Number(product.compare_at_price_min || product.compare_at_price || 0) * 100);
        var onSale = compareAt > price && price > 0;
        var priceClass = 'moss-header__search-card-price' + (onSale ? ' moss-header__search-card-price--sale' : '');
        var priceHtml = '<span class="' + priceClass + '">' + escapeHtml(formatMoney(price))
          + (onSale ? '<span class="moss-header__search-card-compare">' + escapeHtml(formatMoney(compareAt)) + '</span>' : '')
          + '</span>';
        var saleBadgeHtml = onSale ? '<span class="moss-sale-badge" aria-label="On sale">SALE</span>' : '';
        var soldOut = product.available === false;
        var soldOutBadgeHtml = soldOut ? '<span class="moss-soldout-badge" aria-label="Sold out">SOLD OUT</span>' : '';

        return (
          '<a class="moss-header__search-card" href="' + escapeHtml(url) + '">'
          + '<div class="moss-header__search-card-image">' + saleBadgeHtml + soldOutBadgeHtml + imageHtml + '</div>'
          + (vendor ? '<p class="moss-header__search-card-brand">' + vendor + '</p>' : '')
          + '<p class="moss-header__search-card-title">' + title + '</p>'
          + priceHtml
          + '</a>'
        );
      }

      function showSearchResults() {
        if (searchResults) searchResults.hidden = false;
      }

      function hideSearchResults() {
        if (searchResults) searchResults.hidden = true;
        if (searchGrid) searchGrid.innerHTML = '';
        if (searchStatus) searchStatus.textContent = '';
        if (searchViewAll) searchViewAll.hidden = true;
      }

      function runPredictiveSearch(query) {
        if (!searchResults || !searchGrid || !searchStatus) return;

        if (searchAbortController) {
          try { searchAbortController.abort(); } catch (e) {}
        }
        searchAbortController = ('AbortController' in window) ? new AbortController() : null;

        showSearchResults();
        searchStatus.textContent = 'Searching…';
        searchViewAll.hidden = true;

        var url = '/search/suggest.json?q=' + encodeURIComponent(query)
          + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';

        fetch(url, { signal: searchAbortController ? searchAbortController.signal : undefined })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (query !== searchLastQuery) return;

            var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];

            if (products.length === 0) {
              searchGrid.innerHTML = '';
              searchStatus.textContent = 'No results for "' + query + '"';
              searchViewAll.hidden = true;
              return;
            }

            searchStatus.textContent = products.length + ' result' + (products.length === 1 ? '' : 's');
            searchGrid.innerHTML = products.map(renderSearchCard).join('');
            searchViewAll.href = '/search?q=' + encodeURIComponent(query);
            searchViewAll.hidden = false;
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            if (query !== searchLastQuery) return;
            searchStatus.textContent = 'Search failed. Please try again.';
            searchGrid.innerHTML = '';
            searchViewAll.hidden = true;
          });
      }

      function handleSearchInput() {
        syncSearchClearState();
        var query = (searchInput.value || '').trim();
        searchLastQuery = query;

        if (searchDebounceTimer) {
          window.clearTimeout(searchDebounceTimer);
        }

        if (query.length < 2) {
          hideSearchResults();
          return;
        }

        searchDebounceTimer = window.setTimeout(function () {
          runPredictiveSearch(query);
        }, 220);
      }

      if (searchToggle && searchPanel) {
        searchToggle.addEventListener('click', function () {
          var isOpen = sectionRoot.classList.contains('is-search-open');
          setSearchOpenState(!isOpen);
        });

        if (searchInput && searchClear) {
          searchInput.addEventListener('input', handleSearchInput);
          searchInput.addEventListener('change', syncSearchClearState);

          searchClear.addEventListener('click', function () {
            searchInput.value = '';
            searchLastQuery = '';
            syncSearchClearState();
            hideSearchResults();
            searchInput.focus();
          });

          syncSearchClearState();
        }

        document.addEventListener('click', function (event) {
          if (!sectionRoot.isConnected) {
            return;
          }

          if (!sectionRoot.classList.contains('is-search-open')) {
            return;
          }

          if (sectionRoot.contains(event.target)) {
            if (searchToggle.contains(event.target) || searchPanel.contains(event.target)) {
              return;
            }
          }

          setSearchOpenState(false, { focusInput: false });
        });

        document.addEventListener('keydown', function (event) {
          if (event.key == 'Escape') {
            setSearchOpenState(false, { focusInput: false });
            setCartPreviewOpen(false);
          }
        });
      }

      if (toggle && panel) {
        var mobileDisclosureToggles = Array.prototype.slice.call(panel.querySelectorAll('[data-mobile-disclosure-toggle]'));

        mobileDisclosureToggles.forEach(function (disclosureToggle) {
          disclosureToggle.addEventListener('click', function () {
            var disclosure = disclosureToggle.closest('[data-mobile-disclosure]');
            if (!disclosure) {
              return;
            }

            var disclosurePanel = disclosure.querySelector('[data-mobile-disclosure-panel]');
            var isOpen = disclosureToggle.getAttribute('aria-expanded') === 'true';
            disclosureToggle.setAttribute('aria-expanded', String(!isOpen));

            if (disclosurePanel) {
              if (isOpen) {
                disclosurePanel.setAttribute('hidden', '');
              } else {
                disclosurePanel.removeAttribute('hidden');
              }
            }
          });
        });

        toggle.addEventListener('click', function () {
          setSearchOpenState(false, { focusInput: false });
          setCartPreviewOpen(false);
          var isOpen = panel.classList.contains('is-open');
          panel.classList.toggle('is-open', !isOpen);
          panel.hidden = isOpen;
          sectionRoot.classList.toggle('is-menu-open', !isOpen);
          toggle.setAttribute('aria-expanded', String(!isOpen));
        });

        panel.querySelectorAll('a').forEach(function (link) {
          link.addEventListener('click', function () {
            panel.classList.remove('is-open');
            panel.hidden = true;
            sectionRoot.classList.remove('is-menu-open');
            toggle.setAttribute('aria-expanded', 'false');
            mobileDisclosureToggles.forEach(function (disclosureToggle) {
              var disclosure = disclosureToggle.closest('[data-mobile-disclosure]');
              var disclosurePanel = disclosure ? disclosure.querySelector('[data-mobile-disclosure-panel]') : null;
              disclosureToggle.setAttribute('aria-expanded', 'false');
              if (disclosurePanel) {
                disclosurePanel.hidden = true;
              }
            });
          });
        });

        window.addEventListener('resize', function () {
          if (window.innerWidth > 1023) {
            panel.classList.remove('is-open');
            panel.hidden = true;
            sectionRoot.classList.remove('is-menu-open');
            toggle.setAttribute('aria-expanded', 'false');
            mobileDisclosureToggles.forEach(function (disclosureToggle) {
              var disclosure = disclosureToggle.closest('[data-mobile-disclosure]');
              var disclosurePanel = disclosure ? disclosure.querySelector('[data-mobile-disclosure-panel]') : null;
              disclosureToggle.setAttribute('aria-expanded', 'false');
              if (disclosurePanel) {
                disclosurePanel.hidden = true;
              }
            });
          } else {
            setSearchOpenState(false, { focusInput: false });
            setCartPreviewOpen(false);
          }
        });
      }
    }

    function initAllHeaders(root) {
      var scope = root || document;
      if (scope.matches && scope.matches('[data-moss-header]')) {
        initHeader(scope);
      }
      scope.querySelectorAll('[data-moss-header]').forEach(initHeader);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAllHeaders(document);
      });
    } else {
      initAllHeaders(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event && event.target) {
        initAllHeaders(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moss-brands-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(carouselRoot) {
      if (!carouselRoot || carouselRoot.dataset.carouselReady === 'true') {
        return;
      }

      var scroller = carouselRoot.querySelector('[data-carousel-scroller]');
      if (!scroller) {
        carouselRoot.dataset.carouselReady = 'true';
        return;
      }

      var track = carouselRoot.querySelector('[data-carousel-track]');
      var prevButton = carouselRoot.querySelector('[data-carousel-prev]');
      var nextButton = carouselRoot.querySelector('[data-carousel-next]');
      var startSide = carouselRoot.dataset.carouselStart || 'left';
      var hasUserInteracted = false;

      function stepSize() {
        var firstCard = scroller.querySelector('.moss-brands-page__card');
        if (!firstCard) {
          return scroller.clientWidth;
        }

        var styleSource = track || scroller;
        var styles = window.getComputedStyle(styleSource);
        var gap = parseFloat(styles.columnGap || styles.gap || '0');
        return firstCard.getBoundingClientRect().width + gap;
      }

      function updateState() {
        var maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        var current = Math.min(maxScroll, Math.max(0, scroller.scrollLeft));

        if (prevButton) {
          prevButton.disabled = current <= 2;
        }

        if (nextButton) {
          nextButton.disabled = current >= maxScroll - 2;
        }

      }

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          hasUserInteracted = true;
          scroller.scrollBy({ left: -stepSize(), behavior: 'smooth' });
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          hasUserInteracted = true;
          scroller.scrollBy({ left: stepSize(), behavior: 'smooth' });
        });
      }

      function anchorScrollerToStartSide() {
        if (startSide == 'right') {
          scroller.scrollLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        } else {
          scroller.scrollLeft = 0;
        }
        updateState();
      }

      scroller.addEventListener('scroll', function () {
        hasUserInteracted = true;
        updateState();
      }, { passive: true });

      window.addEventListener('resize', function () {
        if (hasUserInteracted) {
          updateState();
        } else {
          anchorScrollerToStartSide();
        }
      });

      updateState();
      window.requestAnimationFrame(anchorScrollerToStartSide);
      window.setTimeout(function () {
        if (!hasUserInteracted) {
          anchorScrollerToStartSide();
        }
      }, 80);

      carouselRoot.dataset.carouselReady = 'true';
    }

    function initCardImageCycle(cardRoot) {
      if (!cardRoot || cardRoot.dataset.cardCycleReady === 'true') {
        return;
      }

      var media = cardRoot.querySelector('[data-card-media]');
      if (!media) {
        cardRoot.dataset.cardCycleReady = 'true';
        return;
      }

      var images = Array.prototype.slice.call(media.querySelectorAll('.moss-brands-page__card-image'));
      var progressSteps = Array.prototype.slice.call(media.querySelectorAll('[data-card-progress-step]'));

      if (images.length <= 1 || progressSteps.length <= 1) {
        cardRoot.dataset.cardCycleReady = 'true';
        return;
      }

      var cycleDuration = Number(media.dataset.cycleDuration || 1600);
      if (!isFinite(cycleDuration) || cycleDuration < 350) {
        cycleDuration = 1600;
      }

      var activeIndex = 0;
      var rafId = null;
      var isRunning = false;
      var cycleStartTime = 0;

      function setProgress(step, value) {
        if (!step) {
          return;
        }

        var fill = step.querySelector('[data-card-progress-fill]');
        if (!fill) {
          return;
        }

        var normalized = Math.max(0, Math.min(100, value));
        fill.style.setProperty('--card-progress', normalized + '%');
      }

      function resetProgress() {
        progressSteps.forEach(function (step) {
          step.classList.remove('is-active');
          setProgress(step, 0);
        });
      }

      function setActiveImage(index) {
        activeIndex = index;

        images.forEach(function (image, imageIndex) {
          image.classList.toggle('is-active', imageIndex === index);
        });

        progressSteps.forEach(function (step, stepIndex) {
          var isCurrent = stepIndex === index;
          step.classList.toggle('is-active', isCurrent);

          if (stepIndex < index) {
            setProgress(step, 100);
          } else if (stepIndex > index) {
            setProgress(step, 0);
          }
        });

        setProgress(progressSteps[index], 0);
      }

      function stopCycle() {
        isRunning = false;
        cardRoot.classList.remove('is-cycling');

        if (rafId) {
          window.cancelAnimationFrame(rafId);
          rafId = null;
        }

        resetProgress();
        images.forEach(function (image, index) {
          image.classList.toggle('is-active', index === 0);
        });
      }

      function frame(now) {
        if (!isRunning) {
          return;
        }

        var elapsed = now - cycleStartTime;
        var progress = Math.max(0, Math.min(1, elapsed / cycleDuration));
        setProgress(progressSteps[activeIndex], progress * 100);

        if (progress >= 1) {
          setProgress(progressSteps[activeIndex], 100);

          var nextIndex = activeIndex + 1;
          if (nextIndex >= images.length) {
            nextIndex = 0;
            resetProgress();
          }

          cycleStartTime = now;
          setActiveImage(nextIndex);
        }

        rafId = window.requestAnimationFrame(frame);
      }

      function startCycle() {
        if (isRunning) {
          return;
        }

        resetProgress();
        setActiveImage(0);
        isRunning = true;
        cardRoot.classList.add('is-cycling');
        cycleStartTime = window.performance && performance.now ? performance.now() : Date.now();
        rafId = window.requestAnimationFrame(frame);
      }

      cardRoot.addEventListener('mouseenter', startCycle);
      cardRoot.addEventListener('mouseleave', stopCycle);
      cardRoot.addEventListener('focusin', startCycle);
      cardRoot.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!cardRoot.contains(document.activeElement)) {
            stopCycle();
          }
        }, 0);
      });

      cardRoot.dataset.cardCycleReady = 'true';
    }

    function initSection(sectionRoot) {
      if (!sectionRoot || sectionRoot.dataset.mossBrandsReady === 'true') {
        return;
      }

      sectionRoot.querySelectorAll('[data-brand-carousel]').forEach(initCarousel);
      sectionRoot.querySelectorAll('.moss-brands-page__card').forEach(initCardImageCycle);

      var anchorLinks = Array.prototype.slice.call(sectionRoot.querySelectorAll('[data-brand-anchor-link]'));
      var brandSections = Array.prototype.slice.call(sectionRoot.querySelectorAll('[data-brand-section]'));
      var indexBar = sectionRoot.querySelector('.moss-brands-page__index');
      var scrollTicking = false;
      var resizeObserver = null;

      function getHeaderHeight() {
        var header = document.querySelector('.moss-header');
        if (!header) {
          return 57;
        }
        return Math.max(0, header.getBoundingClientRect().height || 57);
      }

      function getIndexHeight() {
        if (!indexBar) {
          return 0;
        }
        return Math.max(0, indexBar.getBoundingClientRect().height || 0);
      }

      function syncStickyOffsets() {
        var headerHeight = getHeaderHeight();
        var indexHeight = getIndexHeight();
        sectionRoot.style.setProperty('--brands-header-height', headerHeight + 'px');
        sectionRoot.style.setProperty('--brands-index-height', indexHeight + 'px');
      }

      function getStickyGap() {
        var configuredGap = window.getComputedStyle(sectionRoot).getPropertyValue('--brands-sticky-gap') || '16px';
        var parsedGap = parseFloat(configuredGap);
        if (isNaN(parsedGap)) {
          return 16;
        }
        return parsedGap;
      }

      function setActiveAnchorById(sectionId) {
        anchorLinks.forEach(function (link) {
          var href = link.getAttribute('href') || '';
          var isActive = href === '#' + sectionId;
          link.classList.toggle('is-active', isActive);
        });
      }

      function updateActiveBrandOnScroll() {
        if (!brandSections.length || !anchorLinks.length) {
          return;
        }

        syncStickyOffsets();
        var headerHeight = getHeaderHeight();
        var indexHeight = getIndexHeight();
        var targetY = window.scrollY + headerHeight + indexHeight + getStickyGap();
        var activeSection = brandSections[0];

        brandSections.forEach(function (section) {
          var top = section.getBoundingClientRect().top + window.scrollY;
          if (top <= targetY) {
            activeSection = section;
          }
        });

        if (activeSection && activeSection.id) {
          setActiveAnchorById(activeSection.id);
        }
      }

      function onScroll() {
        if (scrollTicking) {
          return;
        }

        scrollTicking = true;
        window.requestAnimationFrame(function () {
          updateActiveBrandOnScroll();
          scrollTicking = false;
        });
      }

      anchorLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
          var href = link.getAttribute('href') || '';
          if (href.indexOf('#') === 0) {
            var sectionId = href.slice(1);
            var targetSection = document.getElementById(sectionId);
            setActiveAnchorById(sectionId);

            if (targetSection) {
              event.preventDefault();
              syncStickyOffsets();
              var headerHeight = getHeaderHeight();
              var indexHeight = getIndexHeight();
              var stickyGap = getStickyGap();
              var targetY = targetSection.getBoundingClientRect().top + window.scrollY - headerHeight - indexHeight - stickyGap;
              window.scrollTo({
                top: Math.max(0, targetY),
                behavior: 'smooth'
              });
            }
          }
        });
      });

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () {
        syncStickyOffsets();
        updateActiveBrandOnScroll();
      });

      if ('ResizeObserver' in window) {
        resizeObserver = new window.ResizeObserver(function () {
          syncStickyOffsets();
          updateActiveBrandOnScroll();
        });

        if (indexBar) {
          resizeObserver.observe(indexBar);
        }

        var headerNode = document.querySelector('.moss-header');
        if (headerNode) {
          resizeObserver.observe(headerNode);
        }
      }

      syncStickyOffsets();
      updateActiveBrandOnScroll();
      window.setTimeout(function () {
        syncStickyOffsets();
        updateActiveBrandOnScroll();
      }, 160);

      sectionRoot.dataset.mossBrandsReady = 'true';
    }

    function initAll(root) {
      var scope = root || document;
      if (scope.matches && scope.matches('[data-moss-brands-page]')) {
        initSection(scope);
      }
      scope.querySelectorAll('[data-moss-brands-page]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event && event.target) {
        initAll(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moss-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(sectionRoot) {
      var scroller = sectionRoot.querySelector('[data-carousel-scroller]');
      if (!scroller) {
        return;
      }

      var track = sectionRoot.querySelector('[data-carousel-track]');
      var prevButton = sectionRoot.querySelector('[data-carousel-prev]');
      var nextButton = sectionRoot.querySelector('[data-carousel-next]');

      function stepSize() {
        var firstCard = scroller.querySelector('.moss-carousel__card');
        if (!firstCard) {
          return scroller.clientWidth;
        }

        var styleSource = track || scroller;
        var styles = window.getComputedStyle(styleSource);
        var gap = parseFloat(styles.columnGap || styles.gap || '0');
        if (!isFinite(gap)) {
          gap = 0;
        }

        var cardWidth = firstCard.getBoundingClientRect().width;
        if (!isFinite(cardWidth) || cardWidth <= 0) {
          cardWidth = scroller.clientWidth / 4;
        }

        var step = cardWidth + gap;
        if (!isFinite(step) || step <= 0) {
          step = scroller.clientWidth * 0.9;
        }

        return step;
      }

      function updateControls() {
        var maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        var current = Math.min(maxScroll, Math.max(0, scroller.scrollLeft));

        if (prevButton) {
          prevButton.disabled = current <= 2;
        }
        if (nextButton) {
          nextButton.disabled = current >= maxScroll - 2;
        }
      }

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          scroller.scrollBy({ left: -stepSize(), behavior: 'smooth' });
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          scroller.scrollBy({ left: stepSize(), behavior: 'smooth' });
        });
      }

      scroller.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);
      updateControls();
    }

    function initCardCycle(cardRoot) {
      if (!cardRoot || cardRoot.dataset.cardCycleReady === 'true') {
        return;
      }

      var media = cardRoot.querySelector('[data-card-media]');
      if (!media) {
        cardRoot.dataset.cardCycleReady = 'true';
        return;
      }

      var images = Array.prototype.slice.call(media.querySelectorAll('.moss-carousel__image'));
      var progressSteps = Array.prototype.slice.call(media.querySelectorAll('[data-card-progress-step]'));

      if (images.length <= 1 || progressSteps.length <= 1) {
        cardRoot.dataset.cardCycleReady = 'true';
        return;
      }

      var cycleDuration = Number(media.dataset.cycleDuration || 1600);
      if (!isFinite(cycleDuration) || cycleDuration < 350) {
        cycleDuration = 1600;
      }

      var activeIndex = 0;
      var rafId = null;
      var isRunning = false;
      var cycleStartTime = 0;

      function setProgress(step, value) {
        if (!step) {
          return;
        }
        var fill = step.querySelector('[data-card-progress-fill]');
        if (!fill) {
          return;
        }
        var normalized = Math.max(0, Math.min(100, value));
        fill.style.setProperty('--card-progress', normalized + '%');
      }

      function resetProgress() {
        progressSteps.forEach(function (step) {
          step.classList.remove('is-active');
          setProgress(step, 0);
        });
      }

      function setActiveImage(index) {
        activeIndex = index;

        images.forEach(function (image, imageIndex) {
          image.classList.toggle('is-active', imageIndex === index);
        });

        progressSteps.forEach(function (step, stepIndex) {
          var isCurrent = stepIndex === index;
          step.classList.toggle('is-active', isCurrent);

          if (stepIndex < index) {
            setProgress(step, 100);
          } else if (stepIndex > index) {
            setProgress(step, 0);
          }
        });

        setProgress(progressSteps[index], 0);
      }

      function stopCycle() {
        isRunning = false;
        cardRoot.classList.remove('is-cycling');

        if (rafId) {
          window.cancelAnimationFrame(rafId);
          rafId = null;
        }

        resetProgress();
        images.forEach(function (image, index) {
          image.classList.toggle('is-active', index === 0);
        });
      }

      function frame(now) {
        if (!isRunning) {
          return;
        }

        var elapsed = now - cycleStartTime;
        var progress = Math.max(0, Math.min(1, elapsed / cycleDuration));
        setProgress(progressSteps[activeIndex], progress * 100);

        if (progress >= 1) {
          setProgress(progressSteps[activeIndex], 100);

          var nextIndex = activeIndex + 1;
          if (nextIndex >= images.length) {
            nextIndex = 0;
            resetProgress();
          }

          cycleStartTime = now;
          setActiveImage(nextIndex);
        }

        rafId = window.requestAnimationFrame(frame);
      }

      function startCycle() {
        if (isRunning) {
          return;
        }

        resetProgress();
        setActiveImage(0);
        isRunning = true;
        cardRoot.classList.add('is-cycling');
        cycleStartTime = window.performance && performance.now ? performance.now() : Date.now();
        rafId = window.requestAnimationFrame(frame);
      }

      cardRoot.addEventListener('mouseenter', startCycle);
      cardRoot.addEventListener('mouseleave', stopCycle);
      cardRoot.addEventListener('focusin', startCycle);
      cardRoot.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!cardRoot.contains(document.activeElement)) {
            stopCycle();
          }
        }, 0);
      });

      cardRoot.dataset.cardCycleReady = 'true';
    }

    function initSection(sectionRoot) {
      if (!sectionRoot || sectionRoot.dataset.mossCarouselInit === 'true') {
        return;
      }

      sectionRoot.dataset.mossCarouselInit = 'true';
      initCarousel(sectionRoot);
      sectionRoot.querySelectorAll('.moss-carousel__card').forEach(initCardCycle);
    }

    function initAll(root) {
      var scope = root || document;
      if (scope.matches && scope.matches('[data-moss-carousel]')) {
        initSection(scope);
      }
      scope.querySelectorAll('[data-moss-carousel]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event && event.target) {
        initAll(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moss-sale-page"]) return;
  try {
    
  (function () {
    function initCollection(sectionRoot) {
      if (!sectionRoot || sectionRoot.dataset.mossCollectionInit === 'true') {
        return;
      }

      sectionRoot.dataset.mossCollectionInit = 'true';

      var brandFilter = sectionRoot.querySelector('[data-brand-filter]');
      var categoryFilter = sectionRoot.querySelector('[data-category-filter]');
      var categoryMode = sectionRoot.dataset.categoryMode === 'collection' ? 'collection' : 'type';
      var sortSelect = sectionRoot.querySelector('[data-sale-sort]');
      var grid = sectionRoot.querySelector('[data-filter-grid]');
      var cards = Array.prototype.slice.call(sectionRoot.querySelectorAll('[data-filter-card]'));
      var count = sectionRoot.querySelector('[data-filter-count]');
      var empty = sectionRoot.querySelector('[data-filter-empty]');

      if (!cards.length) {
        if (count) {
          count.textContent = '0 products';
        }
        return;
      }

      function initCardImageCycle(cardRoot) {
        if (!cardRoot || cardRoot.dataset.cardCycleReady === 'true') {
          return;
        }

        var media = cardRoot.querySelector('[data-card-media]');
        if (!media) {
          cardRoot.dataset.cardCycleReady = 'true';
          return;
        }

        var images = Array.prototype.slice.call(media.querySelectorAll('.moss-collection__image'));
        var progressSteps = Array.prototype.slice.call(media.querySelectorAll('[data-card-progress-step]'));

        if (images.length <= 1 || progressSteps.length <= 1) {
          cardRoot.dataset.cardCycleReady = 'true';
          return;
        }

        var cycleDuration = Number(media.dataset.cycleDuration || 1600);
        if (!isFinite(cycleDuration) || cycleDuration < 350) {
          cycleDuration = 1600;
        }

        var activeIndex = 0;
        var rafId = null;
        var isRunning = false;
        var cycleStartTime = 0;

        function setProgress(step, value) {
          if (!step) {
            return;
          }
          var fill = step.querySelector('[data-card-progress-fill]');
          if (!fill) {
            return;
          }
          var normalized = Math.max(0, Math.min(100, value));
          fill.style.setProperty('--card-progress', normalized + '%');
        }

        function resetProgress() {
          progressSteps.forEach(function (step) {
            step.classList.remove('is-active');
            setProgress(step, 0);
          });
        }

        function setActiveImage(index) {
          activeIndex = index;

          images.forEach(function (image, imageIndex) {
            image.classList.toggle('is-active', imageIndex === index);
          });

          progressSteps.forEach(function (step, stepIndex) {
            var isCurrent = stepIndex === index;
            step.classList.toggle('is-active', isCurrent);

            if (stepIndex < index) {
              setProgress(step, 100);
            } else if (stepIndex > index) {
              setProgress(step, 0);
            }
          });

          setProgress(progressSteps[index], 0);
        }

        function stopCycle() {
          isRunning = false;
          cardRoot.classList.remove('is-cycling');

          if (rafId) {
            window.cancelAnimationFrame(rafId);
            rafId = null;
          }

          resetProgress();
          images.forEach(function (image, index) {
            image.classList.toggle('is-active', index === 0);
          });
        }

        function frame(now) {
          if (!isRunning) {
            return;
          }

          var elapsed = now - cycleStartTime;
          var progress = Math.max(0, Math.min(1, elapsed / cycleDuration));
          setProgress(progressSteps[activeIndex], progress * 100);

          if (progress >= 1) {
            setProgress(progressSteps[activeIndex], 100);

            var nextIndex = activeIndex + 1;
            if (nextIndex >= images.length) {
              nextIndex = 0;
              resetProgress();
            }

            cycleStartTime = now;
            setActiveImage(nextIndex);
          }

          rafId = window.requestAnimationFrame(frame);
        }

        function startCycle() {
          if (isRunning) {
            return;
          }

          resetProgress();
          setActiveImage(0);
          isRunning = true;
          cardRoot.classList.add('is-cycling');
          cycleStartTime = window.performance && performance.now ? performance.now() : Date.now();
          rafId = window.requestAnimationFrame(frame);
        }

        cardRoot.addEventListener('mouseenter', startCycle);
        cardRoot.addEventListener('mouseleave', stopCycle);
        cardRoot.addEventListener('focusin', startCycle);
        cardRoot.addEventListener('focusout', function () {
          window.setTimeout(function () {
            if (!cardRoot.contains(document.activeElement)) {
              stopCycle();
            }
          }, 0);
        });

        cardRoot.dataset.cardCycleReady = 'true';
      }

      cards.forEach(function (card, index) {
        card.dataset.originalIndex = String(index);
        initCardImageCycle(card);
      });

      // Always start unfiltered when arriving on the Shop page from navbar links.
      if (brandFilter) {
        brandFilter.value = '';
      }
      if (categoryFilter) {
        categoryFilter.value = '';
      }

      function getCardNumber(card, key) {
        var numberValue = Number(card.dataset[key] || 0);
        if (!isFinite(numberValue)) {
          return 0;
        }
        return numberValue;
      }

      function sortCards() {
        if (!grid) {
          return;
        }

        var sortValue = 'title-ascending';
        if (sortSelect) {
          sortValue = sortSelect.value || sortValue;
        }

        var sortedCards = cards.slice().sort(function (cardA, cardB) {
          var titleA = cardA.dataset.sortTitle || '';
          var titleB = cardB.dataset.sortTitle || '';
          var priceA = getCardNumber(cardA, 'sortPrice');
          var priceB = getCardNumber(cardB, 'sortPrice');
          var createdA = getCardNumber(cardA, 'sortCreated');
          var createdB = getCardNumber(cardB, 'sortCreated');

          if (sortValue === 'title-descending') {
            return titleB.localeCompare(titleA);
          }

          if (sortValue === 'price-ascending') {
            return priceA - priceB;
          }

          if (sortValue === 'price-descending') {
            return priceB - priceA;
          }

          if (sortValue === 'created-descending') {
            return createdB - createdA;
          }

          return titleA.localeCompare(titleB);
        });

        sortedCards.forEach(function (card) {
          grid.appendChild(card);
        });
      }

      function cardMatches(card, brandValue, categoryValue) {
        var matchesBrand = true;
        var matchesCategory = true;

        if (brandValue) {
          matchesBrand = card.dataset.brand === brandValue;
        }

        if (categoryValue) {
          if (categoryMode === 'collection') {
            var collectionToken = '|' + categoryValue + '|';
            matchesCategory = !!card.dataset.collections && card.dataset.collections.indexOf(collectionToken) !== -1;
          } else {
            matchesCategory = card.dataset.category === categoryValue;
          }
        }

        if (!matchesBrand) {
          return false;
        }
        if (!matchesCategory) {
          return false;
        }

        return true;
      }

      function applyFilters() {
        var brandValue = '';
        var categoryValue = '';
        if (brandFilter) {
          brandValue = brandFilter.value;
        }
        if (categoryFilter) {
          categoryValue = categoryFilter.value;
        }

        var visibleCount = 0;

        cards.forEach(function (card) {
          var showCard = cardMatches(card, brandValue, categoryValue);
          card.hidden = !showCard;

          if (showCard) {
            visibleCount += 1;
          }
        });

        if (count) {
          if (visibleCount === 1) {
            count.textContent = '1 product';
          } else {
            count.textContent = visibleCount + ' products';
          }
        }

        if (empty) {
          if (visibleCount === 0) {
            empty.hidden = false;
          } else {
            empty.hidden = true;
          }
        }
      }

      if (brandFilter) {
        brandFilter.addEventListener('change', applyFilters);
      }
      if (categoryFilter) {
        categoryFilter.addEventListener('change', applyFilters);
      }
      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          sortCards();
          applyFilters();
        });
      }
      sortCards();
      applyFilters();
    }

    function initAll(root) {
      var scope = root || document;

      if (scope.matches) {
        if (scope.matches('[data-moss-collection]')) {
          initCollection(scope);
        }
      }

      scope.querySelectorAll('[data-moss-collection]').forEach(initCollection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event && event.target) {
        initAll(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function initProduct(sectionRoot) {
      if (!sectionRoot || sectionRoot.dataset.mossProductInit === 'true') {
        return;
      }

      sectionRoot.dataset.mossProductInit = 'true';

      var form = sectionRoot.querySelector('[data-product-form]');
      if (!form) {
        return;
      }

      var variantSelect = form.querySelector('[data-variant-id-select]');
      var optionButtons = Array.prototype.slice.call(form.querySelectorAll('[data-option-button]'));
      var optionGroups = Array.prototype.slice.call(form.querySelectorAll('[data-option-group]'));
      var addToCartButton = form.querySelector('[data-add-to-cart]');
      var quantityInput = form.querySelector('[data-quantity-input]');
      var qtyDecrease = form.querySelector('[data-qty-decrease]');
      var qtyIncrease = form.querySelector('[data-qty-increase]');
      var priceElement = sectionRoot.querySelector('[data-current-price]');
      var mainImage = sectionRoot.querySelector('[data-main-image]');
      var mainImageButton = sectionRoot.querySelector('[data-main-image-button]');
      var thumbButtons = Array.prototype.slice.call(sectionRoot.querySelectorAll('[data-thumb-button]'));
      var lightbox = sectionRoot.querySelector('[data-lightbox]');
      var lightboxDialog = sectionRoot.querySelector('[data-lightbox-dialog]');
      var lightboxImage = sectionRoot.querySelector('[data-lightbox-image]');
      var lightboxPrevButton = sectionRoot.querySelector('[data-lightbox-prev]');
      var lightboxNextButton = sectionRoot.querySelector('[data-lightbox-next]');
      var lightboxSourceNodes = Array.prototype.slice.call(sectionRoot.querySelectorAll('[data-lightbox-source]'));

      if (!variantSelect) {
        return;
      }

      var addLabel = sectionRoot.dataset.addLabel || 'Add to cart';
      var soldOutLabel = sectionRoot.dataset.soldOutLabel || 'Sold out';
      var addingLabel = sectionRoot.dataset.addingLabel || 'Adding...';
      var variantOptions = Array.prototype.slice.call(variantSelect.options);
      var selectedOptions = {};
      var lightboxSources = lightboxSourceNodes
        .map(function (node) {
          return {
            id: node.dataset.imageId || '',
            src: node.dataset.imageSrc || '',
            alt: node.dataset.imageAlt || ''
          };
        })
        .filter(function (item) {
          return item.src !== '';
        });
      if (lightboxSources.length < 2 && thumbButtons.length) {
        var thumbSourceMap = {};
        var thumbSources = [];

        thumbButtons.forEach(function (button) {
          var thumbSrc = button.dataset.thumbSrc || '';
          if (thumbSrc === '' || thumbSourceMap[thumbSrc]) {
            return;
          }

          thumbSourceMap[thumbSrc] = true;
          thumbSources.push({
            id: button.dataset.thumbImageId || '',
            src: thumbSrc,
            alt: button.dataset.thumbAlt || ''
          });
        });

        if (thumbSources.length) {
          lightboxSources = thumbSources;
        }
      }

      if (!lightboxSources.length && mainImage && mainImage.src) {
        lightboxSources.push({
          id: mainImage.dataset.mainImageId || '',
          src: mainImage.src,
          alt: mainImage.alt || ''
        });
      }
      var lightboxIndex = 0;
      var isLightboxOpen = false;
      var lastFocusedElement = null;
      var mainImageTransitionTimer = null;
      var mainImageTransitionId = 0;

      if (lightbox) {
        lightbox.hidden = true;
        document.body.classList.remove('moss-product-lightbox-open');
      }

      function setSelectedOptionsFromVariantOption(variantOption) {
        if (!variantOption) {
          return;
        }

        ['1', '2', '3'].forEach(function (position) {
          var key = 'option' + position;
          if (variantOption.dataset[key]) {
            selectedOptions[position] = variantOption.dataset[key];
          }
        });
      }

      function findMatchingVariantOption() {
        for (var i = 0; i < variantOptions.length; i += 1) {
          var variantOption = variantOptions[i];
          var matchesAll = true;
          var positions = Object.keys(selectedOptions);

          for (var p = 0; p < positions.length; p += 1) {
            var position = positions[p];
            var dataKey = 'option' + position;
            if ((variantOption.dataset[dataKey] || '') !== (selectedOptions[position] || '')) {
              matchesAll = false;
              break;
            }
          }

          if (matchesAll) {
            return variantOption;
          }
        }

        return null;
      }

      function valueIsAvailable(position, value) {
        var dataKey = 'option' + position;

        for (var i = 0; i < variantOptions.length; i += 1) {
          var variantOption = variantOptions[i];
          if ((variantOption.dataset[dataKey] || '') !== value) {
            continue;
          }

          var otherPositions = Object.keys(selectedOptions);
          var otherMatches = true;

          for (var p = 0; p < otherPositions.length; p += 1) {
            var otherPosition = otherPositions[p];
            if (otherPosition === position) {
              continue;
            }

            var otherKey = 'option' + otherPosition;
            if ((variantOption.dataset[otherKey] || '') !== (selectedOptions[otherPosition] || '')) {
              otherMatches = false;
              break;
            }
          }

          if (otherMatches) {
            if (variantOption.dataset.available === 'true') {
              return true;
            }
          }
        }

        return false;
      }

      function normalizedPath(url) {
        if (!url) {
          return '';
        }

        try {
          return new URL(url, window.location.origin).pathname;
        } catch (error) {
          return String(url).split('?')[0];
        }
      }

      function syncThumbStateByImageId(imageId) {
        if (!thumbButtons.length || !imageId) {
          return;
        }

        var activeThumb = null;
        thumbButtons.forEach(function (button) {
          var isMatch = (button.dataset.thumbImageId || '') === String(imageId);
          button.classList.toggle('is-active', isMatch);
          if (isMatch) {
            activeThumb = button;
          }
        });

        if (activeThumb && window.matchMedia('(max-width: 899px)').matches) {
          activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      }

      function preloadGalleryImages() {
        if (!thumbButtons.length) {
          return;
        }

        var preloadedSources = {};

        thumbButtons.forEach(function (button) {
          var src = button.dataset.thumbSrc || '';

          if (!src || preloadedSources[src]) {
            return;
          }

          preloadedSources[src] = true;
          var preloadImage = new Image();
          preloadImage.decoding = 'async';
          preloadImage.src = src;
        });
      }

      function createMainImageGhost() {
        if (!mainImage || !mainImageButton) {
          return null;
        }

        if (!mainImage.currentSrc && !mainImage.src) {
          return null;
        }

        Array.prototype.slice.call(mainImageButton.querySelectorAll('.moss-product__main-image-ghost')).forEach(function (ghostNode) {
          ghostNode.remove();
        });

        var ghost = mainImage.cloneNode(false);
        ghost.removeAttribute('data-main-image');
        ghost.removeAttribute('data-main-image-id');
        ghost.className = 'moss-product__main-image-ghost';
        ghost.src = mainImage.currentSrc || mainImage.src;
        ghost.alt = '';
        ghost.setAttribute('aria-hidden', 'true');
        mainImageButton.appendChild(ghost);

        return ghost;
      }

      function finishMainImageTransition(ghost) {
        window.clearTimeout(mainImageTransitionTimer);
        mainImage.classList.remove('is-entering');

        if (!ghost) {
          return;
        }

        window.requestAnimationFrame(function () {
          ghost.classList.add('is-fading');
        });

        mainImageTransitionTimer = window.setTimeout(function () {
          if (ghost.parentNode) {
            ghost.parentNode.removeChild(ghost);
          }
        }, 280);
      }

      function setMainImage(src, alt, imageId) {
        if (!mainImage || !src) {
          return;
        }

        if (mainImage.src === src || mainImage.currentSrc === src) {
          if (imageId) {
            mainImage.dataset.mainImageId = imageId;
            syncThumbStateByImageId(imageId);
          }
          return;
        }

        var ghost = createMainImageGhost();
        mainImageTransitionId += 1;
        var transitionId = mainImageTransitionId;
        window.clearTimeout(mainImageTransitionTimer);
        mainImage.classList.add('is-entering');
        mainImage.src = src;

        if (typeof alt === 'string' && alt !== '') {
          mainImage.alt = alt;
        }

        if (imageId) {
          mainImage.dataset.mainImageId = imageId;
          syncThumbStateByImageId(imageId);
        } else {
          delete mainImage.dataset.mainImageId;
        }

        if (mainImage.complete) {
          window.requestAnimationFrame(function () {
            if (transitionId !== mainImageTransitionId) {
              return;
            }

            finishMainImageTransition(ghost);
          });
        } else {
          mainImage.addEventListener('load', function handleMainImageLoad() {
            if (transitionId !== mainImageTransitionId) {
              return;
            }

            finishMainImageTransition(ghost);
          }, { once: true });

          mainImageTransitionTimer = window.setTimeout(function () {
            if (transitionId !== mainImageTransitionId) {
              return;
            }

            finishMainImageTransition(ghost);
          }, 600);
        }
      }

      preloadGalleryImages();

      function updateLightboxImage() {
        if (!lightboxImage || !lightboxSources.length) {
          return;
        }

        var total = lightboxSources.length;
        if (lightboxIndex < 0) {
          lightboxIndex = total - 1;
        }
        if (lightboxIndex >= total) {
          lightboxIndex = 0;
        }

        var currentSource = lightboxSources[lightboxIndex];
        lightboxImage.removeAttribute('srcset');
        lightboxImage.removeAttribute('sizes');
        lightboxImage.src = currentSource.src;
        lightboxImage.alt = currentSource.alt || (mainImage && mainImage.alt ? mainImage.alt : 'Product image');

        var multipleImages = lightboxSources.length > 1;
        if (lightboxPrevButton) {
          lightboxPrevButton.disabled = !multipleImages;
        }
        if (lightboxNextButton) {
          lightboxNextButton.disabled = !multipleImages;
        }
      }

      function currentMainImageIndex() {
        if (!lightboxSources.length) {
          return 0;
        }

        var currentImageId = mainImage && mainImage.dataset.mainImageId ? String(mainImage.dataset.mainImageId) : '';
        if (currentImageId !== '') {
          for (var i = 0; i < lightboxSources.length; i += 1) {
            if (String(lightboxSources[i].id) === currentImageId) {
              return i;
            }
          }
        }

        var currentMainPath = normalizedPath(mainImage ? mainImage.src : '');
        if (currentMainPath !== '') {
          for (var s = 0; s < lightboxSources.length; s += 1) {
            if (normalizedPath(lightboxSources[s].src) === currentMainPath) {
              return s;
            }
          }
        }

        return 0;
      }

      function openLightbox(startIndex) {
        if (!lightbox || !lightboxSources.length) {
          return;
        }

        lightboxIndex = typeof startIndex === 'number' ? startIndex : 0;
        updateLightboxImage();
        isLightboxOpen = true;
        lightbox.hidden = false;
        document.body.classList.add('moss-product-lightbox-open');
        lastFocusedElement = document.activeElement;
        if (lightboxDialog) {
          lightboxDialog.focus();
        }
      }

      function closeLightbox() {
        if (!lightbox) {
          return;
        }

        isLightboxOpen = false;
        lightbox.hidden = true;
        document.body.classList.remove('moss-product-lightbox-open');
        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
          lastFocusedElement.focus();
        }
      }

      function goLightboxNext() {
        if (lightboxSources.length < 2) {
          return;
        }

        lightboxIndex += 1;
        updateLightboxImage();
      }

      function goLightboxPrev() {
        if (lightboxSources.length < 2) {
          return;
        }

        lightboxIndex -= 1;
        updateLightboxImage();
      }

      function updateButtonsState() {
        optionButtons.forEach(function (button) {
          var position = button.dataset.optionPosition;
          var value = button.dataset.optionValue;
          var isSelected = selectedOptions[position] === value;
          var isAvailable = valueIsAvailable(position, value);

          button.classList.toggle('is-selected', isSelected);
          button.classList.toggle('is-unavailable', !isAvailable);
          button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          button.disabled = !isAvailable;
          if (!isAvailable) {
            button.setAttribute('aria-disabled', 'true');
          } else {
            button.removeAttribute('aria-disabled');
          }
        });
      }

      function updateVariantUI(variantOption) {
        if (!variantOption) {
          return;
        }

        variantSelect.value = variantOption.value;

        if (priceElement) {
          priceElement.textContent = variantOption.dataset.price || priceElement.textContent;
        }

        var isAvailable = variantOption.dataset.available === 'true';

        if (addToCartButton) {
          addToCartButton.disabled = !isAvailable;
          if (isAvailable) {
            addToCartButton.textContent = addLabel;
          } else {
            addToCartButton.textContent = soldOutLabel;
          }
        }

        if (mainImage) {
          var featuredImage = variantOption.dataset.featuredImage;
          var featuredImageId = variantOption.dataset.featuredImageId || '';
          var featuredImageAlt = mainImage.alt || '';

          if (featuredImageId && thumbButtons.length) {
            for (var i = 0; i < thumbButtons.length; i += 1) {
              if ((thumbButtons[i].dataset.thumbImageId || '') === featuredImageId) {
                if (thumbButtons[i].dataset.thumbAlt) {
                  featuredImageAlt = thumbButtons[i].dataset.thumbAlt;
                }
                break;
              }
            }
          }

          if (featuredImage) {
            setMainImage(featuredImage, featuredImageAlt, featuredImageId);
          }
        }
      }

      function refreshUI() {
        var matchedVariantOption = findMatchingVariantOption();

        if (!matchedVariantOption) {
          matchedVariantOption = variantOptions[0];
          setSelectedOptionsFromVariantOption(matchedVariantOption);
        }

        updateButtonsState();
        updateVariantUI(matchedVariantOption);
      }

      optionGroups.forEach(function (group) {
        var position = group.dataset.optionPosition;
        var selectedButton = group.querySelector('[data-option-button].is-selected');
        if (selectedButton) {
          selectedOptions[position] = selectedButton.dataset.optionValue;
        }
      });

      if (variantSelect.selectedOptions.length > 0) {
        setSelectedOptionsFromVariantOption(variantSelect.selectedOptions[0]);
      }

      optionButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var position = button.dataset.optionPosition;
          selectedOptions[position] = button.dataset.optionValue;
          refreshUI();
        });
      });

      variantSelect.addEventListener('change', function () {
        if (variantSelect.selectedOptions.length > 0) {
          setSelectedOptionsFromVariantOption(variantSelect.selectedOptions[0]);
          refreshUI();
        }
      });

      if (qtyDecrease && quantityInput) {
        qtyDecrease.addEventListener('click', function () {
          var currentValue = Number(quantityInput.value || 1);
          var nextValue = currentValue - 1;
          if (nextValue < 1) {
            nextValue = 1;
          }
          quantityInput.value = String(nextValue);
        });
      }

      if (qtyIncrease && quantityInput) {
        qtyIncrease.addEventListener('click', function () {
          var currentValue = Number(quantityInput.value || 1);
          var nextValue = currentValue + 1;
          quantityInput.value = String(nextValue);
        });
      }

      if (thumbButtons.length && mainImage) {
        thumbButtons.forEach(function (button) {
          button.addEventListener('click', function () {
            var thumbSrc = button.dataset.thumbSrc;
            var thumbAlt = button.dataset.thumbAlt;
            var thumbImageId = button.dataset.thumbImageId || '';

            setMainImage(thumbSrc, thumbAlt, thumbImageId);
          });
        });
      }

      if (mainImageButton && lightboxSources.length > 0) {
        mainImageButton.addEventListener('click', function () {
          openLightbox(currentMainImageIndex());
        });
      }

      if (lightbox) {
        lightbox.addEventListener('click', function (event) {
          var clickTarget = event.target && event.target.closest ? event.target : event.target.parentElement;
          var prevButton = clickTarget ? clickTarget.closest('[data-lightbox-prev]') : null;
          var nextButton = clickTarget ? clickTarget.closest('[data-lightbox-next]') : null;
          var closeButton = clickTarget ? clickTarget.closest('[data-lightbox-close]') : null;

          if (prevButton) {
            event.preventDefault();
            event.stopPropagation();
            goLightboxPrev();
            return;
          }

          if (nextButton) {
            event.preventDefault();
            event.stopPropagation();
            goLightboxNext();
            return;
          }

          if (closeButton) {
            event.preventDefault();
            closeLightbox();
          }
        });
      }

      if (lightboxDialog) {
        lightboxDialog.addEventListener('keydown', function (event) {
          if (!isLightboxOpen) {
            return;
          }

          if (event.key === 'Escape') {
            event.preventDefault();
            closeLightbox();
            return;
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            goLightboxNext();
            return;
          }

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            goLightboxPrev();
          }
        });
      }

      document.addEventListener('keydown', function (event) {
        if (!isLightboxOpen) {
          return;
        }

        if (event.key === 'Escape') {
          event.preventDefault();
          closeLightbox();
          return;
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goLightboxNext();
          return;
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goLightboxPrev();
        }
      });

      if (form && addToCartButton) {
        form.addEventListener('submit', function () {
          if (!addToCartButton.disabled) {
            addToCartButton.textContent = addingLabel;
          }
        });
      }

      refreshUI();
    }

    function initAll(root) {
      var scope = root || document;

      if (scope.matches) {
        if (scope.matches('[data-moss-product]')) {
          initProduct(scope);
        }
      }

      scope.querySelectorAll('[data-moss-product]').forEach(initProduct);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event && event.target) {
        initAll(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    function initSearch(sectionRoot) {
      if (!sectionRoot || sectionRoot.dataset.mossSearchInit === 'true') {
        return;
      }

      sectionRoot.dataset.mossSearchInit = 'true';

      var brandFilter = sectionRoot.querySelector('[data-brand-filter]');
      var categoryFilter = sectionRoot.querySelector('[data-category-filter]');
      var categoryMode = sectionRoot.dataset.categoryMode === 'collection' ? 'collection' : 'type';
      var cards = Array.prototype.slice.call(sectionRoot.querySelectorAll('[data-filter-card]'));
      var count = sectionRoot.querySelector('[data-filter-count]');
      var empty = sectionRoot.querySelector('[data-filter-empty]');

      var searchForm = sectionRoot.querySelector('.moss-search__form');
      var searchInput = sectionRoot.querySelector('[data-search-input]');
      var searchClear = sectionRoot.querySelector('[data-search-clear]');

      if (searchForm && searchInput) {
        function syncFilledState() {
          searchForm.classList.toggle('is-filled', searchInput.value.length > 0);
        }
        searchInput.addEventListener('input', syncFilledState);
        syncFilledState();

        if (searchClear) {
          searchClear.addEventListener('click', function () {
            searchInput.value = '';
            syncFilledState();
            searchInput.focus();
          });
        }
      }

      if (!cards.length) {
        return;
      }

      function initCardImageCycle(cardRoot) {
        if (!cardRoot || cardRoot.dataset.cardCycleReady === 'true') {
          return;
        }

        var media = cardRoot.querySelector('[data-card-media]');
        if (!media) {
          cardRoot.dataset.cardCycleReady = 'true';
          return;
        }

        var images = Array.prototype.slice.call(media.querySelectorAll('.moss-search__image'));
        var progressSteps = Array.prototype.slice.call(media.querySelectorAll('[data-card-progress-step]'));

        if (images.length <= 1 || progressSteps.length <= 1) {
          cardRoot.dataset.cardCycleReady = 'true';
          return;
        }

        var cycleDuration = Number(media.dataset.cycleDuration || 1600);
        if (!isFinite(cycleDuration) || cycleDuration < 350) {
          cycleDuration = 1600;
        }

        var activeIndex = 0;
        var rafId = null;
        var isRunning = false;
        var cycleStartTime = 0;

        function setProgress(step, value) {
          if (!step) {
            return;
          }
          var fill = step.querySelector('[data-card-progress-fill]');
          if (!fill) {
            return;
          }
          var normalized = Math.max(0, Math.min(100, value));
          fill.style.setProperty('--card-progress', normalized + '%');
        }

        function resetProgress() {
          progressSteps.forEach(function (step) {
            step.classList.remove('is-active');
            setProgress(step, 0);
          });
        }

        function setActiveImage(index) {
          activeIndex = index;

          images.forEach(function (image, imageIndex) {
            image.classList.toggle('is-active', imageIndex === index);
          });

          progressSteps.forEach(function (step, stepIndex) {
            var isCurrent = stepIndex === index;
            step.classList.toggle('is-active', isCurrent);

            if (stepIndex < index) {
              setProgress(step, 100);
            } else if (stepIndex > index) {
              setProgress(step, 0);
            }
          });

          setProgress(progressSteps[index], 0);
        }

        function stopCycle() {
          isRunning = false;
          cardRoot.classList.remove('is-cycling');

          if (rafId) {
            window.cancelAnimationFrame(rafId);
            rafId = null;
          }

          resetProgress();
          images.forEach(function (image, index) {
            image.classList.toggle('is-active', index === 0);
          });
        }

        function frame(now) {
          if (!isRunning) {
            return;
          }

          var elapsed = now - cycleStartTime;
          var progress = Math.max(0, Math.min(1, elapsed / cycleDuration));
          setProgress(progressSteps[activeIndex], progress * 100);

          if (progress >= 1) {
            setProgress(progressSteps[activeIndex], 100);

            var nextIndex = activeIndex + 1;
            if (nextIndex >= images.length) {
              nextIndex = 0;
              resetProgress();
            }

            cycleStartTime = now;
            setActiveImage(nextIndex);
          }

          rafId = window.requestAnimationFrame(frame);
        }

        function startCycle() {
          if (isRunning) {
            return;
          }

          resetProgress();
          setActiveImage(0);
          isRunning = true;
          cardRoot.classList.add('is-cycling');
          cycleStartTime = window.performance && performance.now ? performance.now() : Date.now();
          rafId = window.requestAnimationFrame(frame);
        }

        cardRoot.addEventListener('mouseenter', startCycle);
        cardRoot.addEventListener('mouseleave', stopCycle);
        cardRoot.addEventListener('focusin', startCycle);
        cardRoot.addEventListener('focusout', function () {
          window.setTimeout(function () {
            if (!cardRoot.contains(document.activeElement)) {
              stopCycle();
            }
          }, 0);
        });

        cardRoot.dataset.cardCycleReady = 'true';
      }

      cards.forEach(initCardImageCycle);

      if (brandFilter) {
        brandFilter.value = '';
      }
      if (categoryFilter) {
        categoryFilter.value = '';
      }

      function cardMatches(card, brandValue, categoryValue) {
        var matchesBrand = true;
        var matchesCategory = true;

        if (brandValue) {
          matchesBrand = card.dataset.brand === brandValue;
        }

        if (categoryValue) {
          if (categoryMode === 'collection') {
            var collectionToken = '|' + categoryValue + '|';
            matchesCategory = !!card.dataset.collections && card.dataset.collections.indexOf(collectionToken) !== -1;
          } else {
            matchesCategory = card.dataset.category === categoryValue;
          }
        }

        if (!matchesBrand) {
          return false;
        }
        if (!matchesCategory) {
          return false;
        }

        return true;
      }

      function applyFilters() {
        var brandValue = brandFilter ? brandFilter.value : '';
        var categoryValue = categoryFilter ? categoryFilter.value : '';

        var visibleCount = 0;

        cards.forEach(function (card) {
          var showCard = cardMatches(card, brandValue, categoryValue);
          card.hidden = !showCard;
          if (showCard) {
            visibleCount += 1;
          }
        });

        if (count) {
          if (visibleCount === 1) {
            count.textContent = '1 result';
          } else {
            count.textContent = visibleCount + ' results';
          }
        }

        if (empty) {
          empty.hidden = visibleCount !== 0;
        }
      }

      if (brandFilter) {
        brandFilter.addEventListener('change', applyFilters);
      }
      if (categoryFilter) {
        categoryFilter.addEventListener('change', applyFilters);
      }
      applyFilters();
    }

    function initAll(root) {
      var scope = root || document;
      if (scope.matches && scope.matches('[data-moss-search]')) {
        initSearch(scope);
      }
      scope.querySelectorAll('[data-moss-search]').forEach(initSearch);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event && event.target) {
        initAll(event.target);
      }
    });
  })();


  } catch(e) { console.error(e); }
})();
})();
